import { HierarchyType } from '@mcf/ui-core';
export const getUserHierarchyResult = [
    {
        assetCount: 456,
        assetFeatureTags: [],
        driverCount: 123,
        entityOrderType: 'someEntityOrderType',
        id: 'RootHierarchyId',
        name: 'Root Hierarchy Name',
        parentNodeId: null,
        type: HierarchyType.HIERARCHY,
    },
    {
        assetCount: 456,
        assetFeatureTags: [],
        driverCount: 123,
        entityOrderType: 'someEntityOrderType',
        id: 'vehicle1Id',
        name: 'Vehicle 1 Name',
        parentNodeId: 'RootHierarchyId',
        type: HierarchyType.VEHICLE,
    },
    {
        assetCount: 888,
        assetFeatureTags: [],
        driverCount: 999,
        entityOrderType: 'someEntityOrderType',
        id: 'vehicle2Id',
        name: 'Vehicle 2 Name',
        parentNodeId: 'RootHierarchyId',
        type: HierarchyType.VEHICLE,
    },
    {
        assetCount: 456,
        assetFeatureTags: [],
        driverCount: 123,
        entityOrderType: 'someEntityOrderType',
        id: 'PopulatedHierarchyId',
        name: 'Populated Hierarchy Name',
        parentNodeId: 'RootHierarchyId',
        type: HierarchyType.HIERARCHY,
    },
    {
        assetCount: 456,
        assetFeatureTags: [],
        driverCount: 123,
        entityOrderType: 'someEntityOrderType',
        id: 'subVehicle1Id',
        name: 'Sub Vehicle 1 Name',
        parentNodeId: 'PopulatedHierarchyId',
        type: HierarchyType.VEHICLE,
    },
    {
        assetCount: 888,
        assetFeatureTags: [],
        driverCount: 999,
        entityOrderType: 'someEntityOrderType',
        id: 'subVehicle2Id',
        name: 'Sub Vehicle 2 Name',
        parentNodeId: 'PopulatedHierarchyId',
        type: HierarchyType.VEHICLE,
    },
    {
        assetCount: 15,
        assetFeatureTags: [],
        driverCount: 453,
        entityOrderType: 'someEntityOrderType',
        id: 'SecondRootHierarchyId',
        name: 'Second Root Hierarchy Name',
        parentNodeId: null,
        type: HierarchyType.HIERARCHY,
    },
    {
        assetCount: 15,
        assetFeatureTags: [],
        driverCount: 453,
        entityOrderType: 'someEntityOrderType',
        id: 'secondVehicleGroup1Id',
        name: 'Second Vehicle Group 1 Name',
        parentNodeId: 'SecondRootHierarchyId',
        type: HierarchyType.VEHICLE,
    },
    {
        assetCount: 15,
        assetFeatureTags: [],
        driverCount: 453,
        entityOrderType: 'someEntityOrderType',
        id: 'secondVehicle1Id',
        name: 'Second Vehicle 1 Name',
        parentNodeId: 'SecondRootHierarchyId',
        type: HierarchyType.VEHICLE,
    },
    {
        assetCount: 15,
        assetFeatureTags: [],
        driverCount: 453,
        entityOrderType: 'someEntityOrderType',
        id: 'secondVehicleInGroup1Id',
        name: 'Second Vehicle in Group 1 Name',
        parentNodeId: 'secondVehicleGroup1Id',
        type: HierarchyType.VEHICLE,
    },
    {
        assetCount: 15,
        assetFeatureTags: [],
        driverCount: 453,
        entityOrderType: 'someEntityOrderType',
        id: 'deepNestedGroup',
        name: 'Group with child groups',
        parentNodeId: 'RootHierarchyId',
        type: HierarchyType.HIERARCHY,
    },
    {
        assetCount: 15,
        assetFeatureTags: [],
        driverCount: 453,
        entityOrderType: 'someEntityOrderType',
        id: 'deepNestedGroup1',
        name: 'Second Level Group',
        parentNodeId: 'deepNestedGroup',
        type: HierarchyType.HIERARCHY,
    },
    {
        assetCount: 15,
        assetFeatureTags: [],
        driverCount: 453,
        entityOrderType: 'someEntityOrderType',
        id: 'deepNestedGroup--vehicle1',
        name: 'Deep Nested Group - Vehicle 1',
        parentNodeId: 'deepNestedGroup1',
        type: HierarchyType.VEHICLE,
    },
    {
        assetCount: 15,
        assetFeatureTags: [],
        driverCount: 453,
        entityOrderType: 'someEntityOrderType',
        id: 'deepNestedGroup--vehicle2',
        name: 'Deep Nested Group - Vehicle 2',
        parentNodeId: 'deepNestedGroup1',
        type: HierarchyType.VEHICLE,
    },
    {
        assetCount: 15,
        assetFeatureTags: [],
        driverCount: 453,
        entityOrderType: 'someEntityOrderType',
        id: 'deepNestedGroup-LevelThreeGroup',
        name: 'Third Level Group',
        parentNodeId: 'deepNestedGroup1',
        type: HierarchyType.HIERARCHY,
    },
    {
        assetCount: 15,
        assetFeatureTags: [],
        driverCount: 453,
        entityOrderType: 'someEntityOrderType',
        id: 'deepNestedGroup-LevelThreeGroup-vehicle1',
        name: 'Level Three Vehicle 1',
        parentNodeId: 'deepNestedGroup-LevelThreeGroup',
        type: HierarchyType.VEHICLE,
    },
];
export const getUserHierarchyStub = {
    condition: {
        method: 'POST',
        path: '/internal/v1/customer/customerId/hierarchy/person/personId/detail',
    },
    description: ['This is an example stub for a REST request for getUserHierarchy'],
    result: {
        code: 200,
        headers: [],
        response: getUserHierarchyResult,
    },
};
